<template>
	<b-row>
		<b-col class="p-0">
			<b-row>
				<b-col md="6">
					<div class="mh-profile-label">
						<div class="mh-img-wrap">
							<ProfileImage :imageUrl="profilePicture" />
							<span class="mh-user-online"></span>
						</div>
						<span class="mh-title">{{profile.email}}</span>
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col md="6">
					<label class="mh-label required">Activity Name</label>
					<b-input type="text" v-model="name"></b-input>
				</b-col>
				<b-col md="6">
					<label class="mh-label required">Customer/Participant</label>
					<div class="field-with-icon">
						<vue-typeahead-bootstrap :data="customers"
												 :serializer="s => s.name"
												 @hit="($event) => {customerId = $event.id; itemId = null; $refs.itemId.inputValue = ''; getClientServices();}"
												 @keyup="($event) => {
													if($refs.customerId.inputValue == '') {
														customerId = null;
														itemId = null;
														$refs.itemId.inputValue = '';
													}
												 }"
												 autocomplete="off"
												 :showOnFocus="true"
												 :minMatchingChars="1"
												 ref="customerId"></vue-typeahead-bootstrap>
						<i class="mh-icon-search"></i>
					</div>
				</b-col>
			</b-row>
			<b-row v-if="customer != null && customer.risknotification != ''" class="m-0">
				<b-col cols="12">
					<b-alert show variant="danger"><b>Risk:</b> {{customer.risknotification}}</b-alert>
				</b-col>
			</b-row>
			<b-row v-if="customer != null && customer.generalnotes != ''" class="m-0">
				<b-col cols="12">
					<b-alert show variant="info"><b>Formulation:</b> {{customer.generalnotes}}</b-alert>
				</b-col>
			</b-row>
			<b-row>
				<b-col md="12">
					<label class="mh-label">Item</label>
					<div class="field-with-icon">
						<vue-typeahead-bootstrap :data="customerId == null ? [] : clientServices"
												 :serializer="s => s.service"
												 @hit="itemId = $event.serviceid"
												 @keyup="($event) => { $refs.itemId.inputValue != '' ? '' : itemId = null }"
												 autocomplete="off"
												 :showOnFocus="true"
												 :minMatchingChars="1"
												 :placeholder="customerId == null ? 'Select a customer first' : (clientServices.length < 1 ? 'No items available' : '')"
												 ref="itemId"></vue-typeahead-bootstrap>
						<i class="mh-icon-search"></i>
					</div>
				</b-col>
			</b-row>
			<b-row class="mh-action-nav">
				<b-col cols="6">
					<button class="btn btn-default btn-grey" @click="closeForm">Close</button>
				</b-col>
				<b-col cols="6">
					<button class="btn btn-default" @click="clockIn">Clock In</button>
				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
	import ProfileImage from "./ProfileImage"
	import moment from "moment"

	export default {
		name: 'ClockInForm',
		components: {
			ProfileImage
		},
		data: function () {
			return {
				name: null,
				customerId: null,
				itemId: null
			}
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			customers: function () {
				return this.$store.state.Customers.customers
			},
			customer: function () {
				return this.customers.filter(x => x.id === this.customerId)[0]
			},
			profilePicture: function () {
				return this.profile.profilepic
			},
			clientServices: function () {
				return this.$store.state.ClientServices.clientServices
			},
			isNameValid: function () {
				if (this.name == null || this.name == "") {
					this.$store.commit("Toasts/showError", { title: "Name", content: "Name is required" })

					return false
				}

				return true
			},
			isCustomerIdValid: function () {
				if (this.customerId == null) {
					this.$store.commit("Toasts/showError", { title: "Customer", content: "Customer is required" })

					return false
				}

				return true
			},
			isItemIdValid: function () {
				return true
			}
		},
		methods: {
			getClientServices: function () {
				this.$store.dispatch("ClientServices/getClientServices", { customerId: this.customerId, date: moment().format("YYYY-MM-DD") })
			},
			closeForm: function () {
				this.$emit("close-form")
			},
			isFormValid: function () {
				return this.isNameValid
					&& this.isCustomerIdValid
					&& this.isItemIdValid
			},
			clockIn: function () {
				if (!this.isFormValid())
					return

				var parameters = {
					timesheetId: 0,
					hasShift: false,
					shiftId: 0,
					shiftName: this.name,
					userId: this.profile.userid,
					clientId: this.customerId,
					dateFrom: moment().format("YYYY-MM-DD hh:mm:ss a"),
					dateTo: moment().format("YYYY-MM-DD hh:mm:ss a"),
					travelKm: 0,
					transportKm: 0,
					serviceTypeId: this.itemId || -1,
					billable: this.itemId != null,
					serviceScheduleStatus: 1,
					noteTagIds: "",
					notes: "",
					cancellationPolicyId: "0",
					additionalRosterComments: "TimeClock",
					SendEmailNotification: false,
					CreateShiftWithErrors: true
				}

				var $this = this

				this.$store.dispatch("Shifts/createTimesheet", parameters).then(function () {
					$this.$emit("save-form")
				})
			}
		}
	}
</script>

<style scoped>
</style>